<app-horizontal-menu [fragment]="true" [headers]="headers" alignment="center"
                     backgroundColor="#99C6D4" class="submenu" menuHeight="4rem"></app-horizontal-menu>
<div class="flex justify-center">
  <div class="page-container">
    <h2 id="smtpf">{{ headerSmtpf }}</h2>
    <h3 class="paragraph">{{ paragraphSmtpf }}</h3>

    <div class="default-view">
      <ng-container *ngFor="let elem of smtpfInfo;">
        <app-badge [color]="elem.color" [icon]="elem.icon" [text]="elem.text"></app-badge>
      </ng-container>
    </div>
    <div class="small-view">
      <ng-container *ngFor="let elem of smtpfInfo">
        <app-list-element [color]="elem.color" [iconOrIndex]="elem.icon" [icon]="true"
                          [text]="elem.text"></app-list-element>
      </ng-container>
    </div>

    <h2 class="mt-4" id="cls">{{ headerCls }}</h2>
    <h3 class="paragraph">{{ paragraphCls1 }}</h3>
    <div class="flex justify-center mb-2">
      <img alt="smtpf1.png" i18n-src src="assets/cls1.svg" style="width: 50rem;">
    </div>
    <h3 class="paragraph">{{ paragraphCls2 }}</h3>
    <h3 class="paragraph">{{ paragraphCls3 }}</h3>
    <h3 class="paragraph">{{ paragraphCls4 }}</h3>
    <h3 class="paragraph">{{ paragraphCls5 }}</h3>
    <div class="flex justify-center mb-2">
      <img alt="cls1.png" i18n-src src="assets/cls2.svg" style="width: 40rem;">
    </div>
    <h3 class="paragraph">{{ paragraphCls6 }}</h3>
    <h3 class="paragraph">{{ paragraphCls7 }}</h3>
    <div class="mt-2">
      <ng-container *ngFor="let elem of clsInfo; let i = index">
        <app-list-element [color]="elem.color" [iconOrIndex]="(i+1).toString()" [text]="elem.text"></app-list-element>
      </ng-container>
    </div>

    <h2 class="mt-4" id="manufacturer-tool">{{ headerManufacturer }}</h2>
    <h3 class="paragraph">{{ paragraphManufacturer1 }}</h3>
    <h3 class="paragraph">{{ paragraphManufacturer2 }}</h3>
    <h3 class="paragraph">{{ paragraphManufacturer3 }}</h3>
    <h3 [innerHTML]="paragraphManufacturer4" class="paragraph"></h3>
  </div>
</div>
